import { render, staticRenderFns } from "./DisableAccount.vue?vue&type=template&id=9cd1d77a"
import script from "./DisableAccount.vue?vue&type=script&lang=js"
export * from "./DisableAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports